import { ButtonColorVariant } from "@/components/ui/button";
import { RowAction, RowActionVariant } from "@/components/ui/table-row-actions";

const DEFAULT_PRIORITY = 1;
const VARIANT_PRIORITY: Partial<Record<ButtonColorVariant, number>> = {
  [RowActionVariant.Success]: 0,
  [RowActionVariant.Warning]: 2,
  [RowActionVariant.Error]: 3,
};

function getPriority(action: RowAction): number {
  return VARIANT_PRIORITY[action.variant ?? RowActionVariant.Default] ?? DEFAULT_PRIORITY;
}

export function sortRelocationOrderActions(actions: RowAction[]): RowAction[] {
  return actions.toSorted((a, b) => getPriority(a) - getPriority(b));
}
